<div
  [ngClass]="{
    'global-spinner-bg': global(),
    'spinner-bg': !global(),
    'd-flex justify-content-center align-items-center position-absolute w-100 h-100':
      !single(),
  }"
  [class]="class()"
  style="top: 0; left: 0; z-index: 100"
>
  <span
    class="spinner-border text-primary align-middle ms-2"
    [ngClass]="{
      'small-spinner': size() === 'small',
      'big-spinner': size() === 'big',
    }"
    [ngStyle]="{
      width: size() === 'small' ? '3rem' : '6rem',
      height: size() === 'small' ? '3rem' : '6rem',
      'border-width': size() === 'small' ? '0.35rem' : '0.7rem',
    }"
  ></span>
</div>
